'use client'

import { useEffect, useState } from 'react'

export function Time({ className }) {
  const [time, setTime] = useState({
    arg: '',
    cet: '',
  })

  useEffect(() => {
    // Set initial time immediately
    const updateTime = () => {
      setTime({
        arg: new Date().toLocaleTimeString(undefined, {
          timeZone: 'America/Argentina/Buenos_Aires',
          hour: '2-digit',
          minute: '2-digit',
          localeMatcher: 'best fit',
        }),
        cet: new Date().toLocaleTimeString(undefined, {
          timeZone: 'Europe/Paris',
          hour: '2-digit',
          minute: '2-digit',
          localeMatcher: 'best fit',
        }),
      })
    }

    updateTime()

    // Update every minute instead of every second since seconds aren't shown
    const timer = setInterval(updateTime, 60000)

    return () => clearInterval(timer)
  }, [])

  // Don't render anything until we have the initial time
  if (!time.arg || !time.cet) return null

  return (
    <div className="dr-grid dt:col-start-3 dt:col-span-2 col-span-full dt:flex dt:flex-col ">
      <p className="caption smb-40 dt:mb-0 ">ARG {time.arg}</p>
      <p className="caption smb-40 dt:mb-0 col-start-3">CET {time.cet}</p>
    </div>
  )
}
